import {
  flatDoors as loadFlatDoors,
  warehouseDoors as loadWarehouseDoors,
  load,
} from "../animatedObjects/doors.js";
import {
  saveDoorTriggers,
  frameRate,
  doorTriggers,
  puzzleLaunchers,
} from "../babylonScene";
import { assetsManager, assetContainers } from "~src/helpers/assetsManager";
import buildPuzzle8 from "../puzzles/electricControlPanel";
import buildWallSwitch from "../puzzles/wallSwitch";
import { userChoiceTracker } from "../helpers/userChoiceTracker";
import buildPuzzle10 from "../puzzles/lockconsole";
import buildPuzzle1 from "../puzzles/twitter/index.js";
import facebook1Puzzle from "../puzzles/facebook/bunker.js";
import facebook2Puzzle from "../puzzles/facebook/warehouse.js";
import facebook3Puzzle from "../puzzles/facebook/flat.js";
import clockPuzzle from "../puzzles/clock";
import { tip2DImageLauncher } from "../tips/2DImageView/index.js";
import { deleteObjectHelpers } from "../helpers/assetsManager";
import { tips, TipWindow } from "~src/tips/index.js";
import { computerScreens } from "../helpers/computerScreens";
import framegramPuzzle from "~src/puzzles/frameGram";
import emailPuzzle from "~src/puzzles/email/index.js";
import EndingScreen from "~src/fullscreenModals/endingScreen.js";
export const shortcutDetected = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let value = false;
  if (urlParams.has("puzzle")) value = true;
  if (urlParams.has("place")) value = true;
  if (urlParams.has("object")) value = "object";
  console.log(urlParams)
  return value;
};

export const shortcuts = async (scene, customCameraHelpers) => {
  const urlParams = new URLSearchParams(window.location.search);
  const helpers = customCameraHelpers.getHelpers();
  const getCameraPosition = () => {
    const camera = customCameraHelpers.getHelpers().camera;
    const { x, y, z } = camera.position;
    const target = camera.getTarget();
    return `{position: [${x}, ${y}, ${z}], target: [${target.x}, ${target.y}, ${target.z}]}`;
  };
  const camera = customCameraHelpers.getHelpers().camera;
  window.camera = customCameraHelpers.getHelpers().camera;

  document.onkeyup = function (e) {
    if (e.ctrlKey && e.shiftKey && e.which == 67) {
      if (shortcutDetected()) {
        alert(getCameraPosition());
      }
    }
  };

  const everythingUpToWarehouseDoor = async () => {
    assetContainers.warehouse.addToScene(scene);
    const flatDoors = await loadFlatDoors(scene, frameRate);
    saveDoorTriggers(flatDoors);
    doorTriggers.openFlatCorridor();
    doorTriggers.openWarehouse();
   
    const warehouseDoors = await loadWarehouseDoors(scene, frameRate);
    saveDoorTriggers(warehouseDoors);
    return;
  };

  const everythingUpToBunker = async () => {
    tips.magazine.clear()
    await everythingUpToWarehouseDoor();
    doorTriggers.openBunker();
    doorTriggers.openLocker();
    assetContainers.bunker.addToScene(scene);
    return;
  };

  if (urlParams.get("place") === "warehouse") {
    scene.onReadyObservable.add(async () => {
      const cameraData = {
        position: [63.20700695819038, 6.468817336628404, -126.43244948042357],
        target: [63.1805251975246, 6.421243662158218, -127.43096609962905],
      };
      tips.magazine.setTime(40);
      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));
      await everythingUpToWarehouseDoor();
    });
    //doorTriggers.openWarehouse();
    // tips.lookAtTable.setTime(1);
  }

  if (urlParams.get("place") === "bunker") {
    scene.onReadyObservable.add(async () => {
      await everythingUpToBunker();
      doorTriggers.openBunker();
      tips.bunkerFound.setTime(10);
      const cameraData = {
        position: [143.96705181257244, -19.424674879691878, -182.4171815132055],
        target: [144.0432728912067, -19.508241739056388, -181.4235986684713],
      };
      assetContainers.bunker.addToScene(scene);
      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));
    });
  }

  if (urlParams.get("place") === "electricPanel") {
    scene.onReadyObservable.add(async () => {
      await everythingUpToBunker();
      const cameraData = {
        position: [143.96705181257244, -19.424674879691878, -182.4171815132055],
        target: [144.0432728912067, -19.508241739056388, -181.4235986684713],
      };
      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));
      puzzleLaunchers.electricPanel();
    });
  }

  if (urlParams.get("place") === "endSwitch") {
    scene.onReadyObservable.add(async () => {
      const cameraData = {
        position: [45.581961198005935, 14.17480477908031, -35.61015336440213],
        target: [45.403044549975654, 14.070181684879222, -36.58843903468259],
      };
      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));
      userChoiceTracker.solved();
      computerScreens.bunker.lock();
      computerScreens.warehouse.lock();
      computerScreens.flat.open();
      puzzleLaunchers.flatPosterSafari();
    });
  }
  if (urlParams.get("place") === "matrixPoster") {
    scene.onReadyObservable.add(async () => {
      const flatDoors = await loadFlatDoors(scene, frameRate);
      const cameraData = {
        position: [70.15274645619905, 14.17480114884426, -8.591200623913494],
        target: [70.12611931794203, 14.314546980333823, -7.6013713220793875],
      };
      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));
      puzzleLaunchers.matrixPoster();
    });
  }
  if (urlParams.get("place") === "twitterLoggedOut") {
    scene.onReadyObservable.add(async () => {
      //const flatDoors = await loadFlatDoors(scene, frameRate);
      const cameraData = {
        position: [21.445510605220562, 14.174805098369626, -37.98654512046784],
        target: [21.920227954034573, 13.872252040699033, -38.813046847572025],
      };
      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));
      puzzleLaunchers.twitter(false);
    });
  }

  if (urlParams.get("place") === "twitterLoggedIn") {
    scene.onReadyObservable.add(async () => {
      puzzleLaunchers.twitter(true);
    });
  }

  if (urlParams.get("place") === "corridor") {
    scene.onReadyObservable.add(async () => {
      const flatDoors = await loadFlatDoors(scene, frameRate);
      flatDoors.openFlatCorridor();
      const cameraData = {
        position: [63.21063831307472, 6.499209816628406, -68.42085793308043],
        target: [63.120159341474185, 6.288203950100849, -69.39414623073363],
      };
      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));
      puzzleLaunchers.flatDoorKnob();
    });
  }

  if (urlParams.get("place") === "meloniConsole") {
    scene.onReadyObservable.add(async () => {
    
      const flatDoors = await loadFlatDoors(scene, frameRate);
      flatDoors.openFlatCorridor();
;
      const cameraData = {
        position: [54.01306813916171, 6.499212103637243, -85.44250137583286],
        target: [54.08116898646558, 6.163983749898458, -86.38217378632099],
      };
      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));
      puzzleLaunchers.meloniConsole();
    });
  }

  if (urlParams.get("place") === "lockConsole") {
    scene.onReadyObservable.add(async () => {
      await everythingUpToWarehouseDoor();
  const cameraData = {position: [48.14061852221767, 6.468814101472548, -102.35398130989994], target: [48.02497581814806, 6.554536465957812, -101.36439632750476]}
  camera.position = new BABYLON.Vector3(...cameraData.position);
  camera.setTarget(new BABYLON.Vector3(...cameraData.target));


  puzzleLaunchers.lockConsole();

});
  
  }
  
  if (urlParams.get("place") === "facebook-bunker") {
    scene.onReadyObservable.add(async () => {
      userChoiceTracker.electricPanelPuzzleResolved(true);
      await everythingUpToBunker();
      const cameraData = {
        position: [182.1592728604081, -19.42468030403949, -142.04509832910392],
        target: [183.06977088344124, -19.766612153757585, -141.81255590370986],
      };
      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));
      computerScreens.bunker.open();
      puzzleLaunchers.facebookPuzzle();
    });
  }

  if (urlParams.get("place") === "framegram") {
    scene.onReadyObservable.add(async () => {
      userChoiceTracker.electricPanelPuzzleResolved(true);
      await everythingUpToBunker();
      userChoiceTracker.processAnswer("bunkerPuzzle2", true);
      const cameraData = {
        position: [44.093996237970146, 6.4688294140311555, -216.321583307529],
        target: [43.28702325747088, 6.1891469565841035, -216.84174904897264],
      };
      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));
      computerScreens.warehouse.open();
      computerScreens.bunker.lock();
      puzzleLaunchers.frameGram();
    });
  }

  if (urlParams.get("place") === "email") {
    scene.onReadyObservable.add(async () => {
      userChoiceTracker.electricPanelPuzzleResolved(true);
      await everythingUpToBunker();
      userChoiceTracker.processAnswer("warehousePuzzle1", true);
      userChoiceTracker.processAnswer("bunkerPuzzle2", true);
      const cameraData = {
        position: [71.70549292086208, 14.174805011612369, -37.34224694994642],
        target: [72.59053862808788, 13.797756399971439, -37.615245998179454],
      };
      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));
      computerScreens.bunker.lock();
      computerScreens.warehouse.lock();
      computerScreens.flat.open();
      puzzleLaunchers.email();
    });
  }

  if (urlParams.get("place") === "clock") {
    scene.onReadyObservable.add(async () => {
      const cameraData = {
        position: [110.73811978594826, 6.468827040338221, -198.65477147311142],
        target: [111.72470951573418, 6.312474892878237, -198.7016189134138],
      };

      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));

      await everythingUpToWarehouseDoor();

      puzzleLaunchers.clock();
    });
  }

  if (urlParams.get("place") === "magazine") {
    scene.onReadyObservable.add(async () => {
      await everythingUpToWarehouseDoor();
      const cameraData = {
        position: [64.52588902530759, 6.468818306197473, -133.6487132440836],
        target: [65.47321365890592, 6.155798225869486, -133.71649559396812],
      };

      camera.position = new BABYLON.Vector3(...cameraData.position);
      camera.setTarget(new BABYLON.Vector3(...cameraData.target));

      tip2DImageLauncher.magazine();
    });
  }

  if (urlParams.has("object")) {
    const name = urlParams.get("object");
    tip2DImageLauncher[name]();
  }
};
